// extracted by mini-css-extract-plugin
module.exports = {"root":"_1tu4A","count":"_3hyRl"};